export const it = {
  scene: {
    loading: 'Caricamento dello sfondo…',
    recovering: 'Ripristino dell’immagine…',
    unavailable: 'Impossibile caricare lo sfondo',
    retryHint:
      'Nuovo tentativo in corso. Se il caricamento non termina, riapri l’app.',
  },
  bootstrap: {
    unsupportedBrowser: {
      title: 'Questo browser non è supportato',
      description: 'La grafica dell’app non è disponibile con la configurazione attuale del browser. Apri Neiro Oracle in un altro browser dall’elenco qui sotto.',
      browsers: 'Browser supportati',
      requirement: 'Usa una versione aggiornata con grafica WebGL disponibile. Le impostazioni del browser o del dispositivo possono limitarne il funzionamento.',
      safari: 'Safari · iPhone, iPad e Mac',
    },
    loadingSpace: 'Preparazione dello spazio…',
    loadingOracle: 'Apertura dell’Oracolo…',
    startupError: 'Impossibile avviare l’app',
    retry: 'Riprova',
    staleTelegram:
      'La sessione Telegram è scaduta. Chiudi e riapri la Mini App.',
    authTelegramError: 'Impossibile confermare l’accesso con Telegram',
    updateTelegramError:
      'Impossibile aggiornare la Mini App. Chiudila completamente e riaprila.',
    missingTelegramData:
      'Telegram non ha fornito i dati di avvio. Chiudi e riapri la Mini App.',
  },
  back: 'Indietro',
  close: 'Chiudi',
  loading: 'Caricamento…',
  routeReading: {
    loading: 'Apertura della lettura…',
    error: 'Lettura non disponibile',
    errorHint:
      'Potrebbe essere stata eliminata o appartenere a un altro profilo.',
    retry: 'Riprova',
  },
  save: 'Salva',
  tomorrow: 'Domani',
  collapse: 'Comprimi',
  app: {
    title: 'NEIRO ORACLE',
    subtitle: 'Sistema di divinazione v{{version}}',
    version: 'v{{version}}',
  },
  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: 'Come funziona l’Oracolo',
    introduction:
      'Due modi per consultare l’I Ching in base alle tue esigenze.',
    accessibilityLabel: 'Guida al segno del giorno e alle letture',
    open: 'Come usare l’Oracolo',
    close: 'Chiudi la guida',
    understood: 'Ho capito',
    daily: {
      title: 'Segno del giorno',
      body: 'Non serve una domanda. Il segno offre un tema e un orientamento pratico per la giornata.',
    },
    reading: {
      title: 'Lettura',
      body: 'Formula una domanda precisa e tienila a mente mentre lanci le monete. La lettura mostra la situazione attuale, i suoi cambiamenti e una possibile direzione.',
    },
    journal: {
      title: 'Diario',
      body: 'I segni del giorno e le letture condividono la stessa cronologia. Dopo una lettura puoi annotare una decisione.',
    },
    example: {
      title: 'Una domanda utile',
      body: '«Cosa dovrei considerare prima di parlare con il mio team?»',
    },
  },
  dailyDetails: {
    title: 'Dettagli',
    loading: 'Caricamento del segno…',
    loadError: 'Impossibile caricare il segno nella lingua selezionata.',
    retry: 'Riprova',
    fullText: 'Tema di oggi',
    situationEssence: 'Domanda di verifica',
    innerTension: 'Da tenere a mente',
    action: 'Cosa fare oggi',
    askAbout: 'Fai una domanda su questo',
    introduction:
      'Il segno del giorno non richiede una domanda. Offre un tema e un orientamento pratico per la giornata.',
  },
  classicalText: {
    title: 'TESTO CLASSICO',
    future: 'CLASSICO · SEGNO FUTURO',
    judgment: 'RESPONSO DELL’ESAGRAMMA',
    lines: 'RESPONSI DELLE LINEE',
    parallelLines: 'LINEE DELL’ESAGRAMMA',
    line: 'Linea {{number}}',
    lineStatement: 'RESPONSO CLASSICO',
    sourceLabel: 'I Ching',
    rulingLine: 'LINEA DOMINANTE',
    specialLine: 'Responso speciale',
  },
  home: {
    title: 'NEIRO ORACLE',
    subtitle: 'Sistema di divinazione v{{version}}',
    statusText: '> Tutti i sistemi operativi',
    daily: {
      title: 'Segno del giorno',
      caption: 'Senza domanda · tema e guida per la giornata',
      actionTitle: 'Azione per oggi',
      askNow: 'Inizia una lettura',
      moreDetails: 'Leggi di più',
      hideDetails: 'Nascondi i dettagli',
      detailsTitle: 'Descrizione completa',
      lastResult: 'Ultimo risultato',
      noLastResult: 'Nessuna',
      emptyState: 'Nessuna lettura. Inizia una lettura →',
      empty: {
        subtitle: 'Tocca per ricevere il segno di oggi',
        hint: 'Rituale con un tocco',
        button: 'Ricevi il segno',
      },
      loading: {
        searching: 'Ricerca dell’esagramma…',
        revealing: 'Rivelazione delle sei linee…',
      },
      pinnedToday: 'Fissato per oggi',
      newSign: 'Nuovo segno',
      resetReasons: {
        title: 'Motivo dell’aggiornamento',
        sleep: 'Risveglio dopo il sonno',
        situationChanged: 'La situazione è cambiata',
        other: 'Altro',
      },
      resetConfirm: {
        title: 'Aggiornare il segno?',
        message:
          'Aggiornare il segno per un nuovo ciclo di veglia? Quello attuale resterà nel diario.',
        confirm: 'Aggiorna',
        cancel: 'Annulla',
      },
      nextUpdate: {
        prefix: 'Prossimo nuovo segno —',
        afterSleep: 'dopo il prossimo sonno',
        tomorrow: 'domani alle 07:00',
        or: 'o',
        available: 'disponibile ora',
      },
      updated: 'Segno aggiornato — nuovo ciclo di veglia',
      limitReached: 'Limite di aggiornamenti giornalieri raggiunto',
      disclaimer:
        'Per riflessione personale e intrattenimento. Non è un consiglio medico o finanziario.',
    },
    question: {
      title: 'Hai una domanda precisa?',
      subtitle:
        'Una lettura esplora la situazione, i suoi cambiamenti e una possibile direzione',
      askNow: 'Inizia una lettura',
      hint: 'Senza tema. Mostra l’esagramma futuro e le linee attuali e mutevoli',
    },
    buttons: {
      iching: 'ORACOLO I CHING',
      designSystem: 'SISTEMA DI DESIGN',
      simpleTest: 'TEST SEMPLICE',
      hexagramTest: 'TEST DEGLI ESAGRAMMI',
    },
  },
  iching: {
    title: 'ORACOLO I CHING',
    subtitle: 'MOBILE v{{version}}',
    throwCoins: 'Lancia le monete',
    castingHexagram: 'Formazione dell’esagramma…',
    generationError:
      'Il segno non si è formato. Controlla la connessione e ripeti il rituale.',
    retry: 'Riprova',
    castingWisdom: {
      '1': 'Un viaggio di mille li inizia con un solo passo',
      '2': 'Non temere di andare piano; temi di restare fermo',
      '3': 'Il morbido supera il duro, la quiete supera l’irrequietezza',
      '4': 'Il cambiamento è l’unica costante sotto il cielo',
      '5': 'Il saggio si adatta come l’acqua alla forma del recipiente',
      '6': 'Quando il segno prende forma, la risposta è già dentro di te',
    },
    instruction: 'Tocca per formare il tuo esagramma e ricevere una guida',
    linkActive: 'COLLEGAMENTO ATTIVO',
    backButton: '← HOME',
    newDivination: 'NUOVA DIVINAZIONE',
    sections: {
      hexagrams: 'ESAGRAMMI',
      interpretation: 'INTERPRETAZIONE',
      aiInsights: 'APPROFONDIMENTI IA',
      general: 'INTERPRETAZIONE GENERALE',
      love: 'AMORE E RELAZIONI',
      work: 'LAVORO E CARRIERA',
      health: 'SALUTE E BENESSERE',
      travel: 'VIAGGI E CAMMINO',
      changingLines: 'LINEE MUTEVOLI',
      futureHexagram: 'STATO POSSIBILE',
      structuralFocus: 'COSA SOSTIENE LA SITUAZIONE',
    },
    hexagram: {
      current: 'ATTUALE',
      future: 'POSSIBILE',
      present: 'SITUAZIONE ATTUALE',
      outcome: 'DIREZIONE POSSIBILE',
      changing: 'LINEE MUTEVOLI',
      structural: 'COSA LA TIENE INSIEME',
    },
    insights: {
      analyzing: 'Elaborazione della lettura…',
      transformation:
        '«{{current}}» può evolvere verso «{{future}}». Linee mutevoli: {{changes}}.',
      stable:
        'Nessuna linea cambia. La situazione mantiene la direzione attuale.',
    },
    changingLines: 'Linee mutevoli',
    changingLinesDescription:
      'Queste linee mostrano dove la situazione può cambiare.',
    governingLineHint: 'La corona indica una linea dominante di questo esagramma.',
    allLinesTitle: 'Tutte le linee ({{count}})',
    stableLineReadingsHint: 'Le linee non cambiano. Sono mostrate tutte e sei le linee dell’esagramma.',
    changingLinesTitle: 'Linee mutevoli ({{count}})',
    structuralFocusTitle: 'Cosa tiene insieme la situazione',
    structuralFocusDescription:
      'Quando nessuna linea cambia, queste posizioni mostrano cosa tiene insieme la situazione attuale.',
    lineNumber: 'Linea {{number}}',
    changingLinesNote:
      'Leggi queste linee con attenzione: mostrano dove avviene il cambiamento.',
  },
  ask: {
    throw: {
      prepare: 'Formula brevemente la domanda e tienila a mente.',
      tips: {
        heart: 'Esprimi ciò che conta per te',
        specific: 'Descrivi la situazione concreta',
        openEnded: 'Chiedi cosa dovresti considerare',
      },
      example: 'Per esempio: «Cosa dovrei considerare prima di decidere?»',
      guide: {
        title: 'Preparazione',
        bestTime: 'Chiedi quando sei pronto a valutare la risposta con calma',
        todayGood:
          'Lascia il tempo di verificare i fatti prima di una decisione importante',
      },
    },
    result: {
      sections: {
        future: 'Direzione possibile',
        present: 'Cosa sta accadendo ora',
        changes: 'Punto focale della lettura',
        structuralFocus: 'Cosa la tiene insieme',
        advice: 'Come agire',
      },
      accessibility: {
        advice: 'Come agire. Consiglio',
      },
      content: {
        check: 'Domanda di verifica',
        caution: 'Da tenere a mente',
        primaryLine: 'Punto principale',
        secondaryLine: 'Dettaglio aggiuntivo',
        relatingHint:
          'L’esagramma risultante offre un altro tema da confrontare con la situazione.',
        visibleStructure: 'Come prende forma la situazione',
        resultStructure: 'Come può evolvere la situazione',
        hiddenDynamic: 'Cosa accade sotto la superficie',
        hiddenCondition: 'Cosa può influire sull’esito',
        corePattern: 'Cosa notare',
        coreTension: 'Dove sta la difficoltà',
        question: 'La tua domanda',
        questionContext: 'Nel contesto della domanda',
        currentAction: 'Cosa fare ora',
        entryCondition: 'Come avvicinarti',
        progressMarker: 'Come riconoscere i progressi',
      },
      changeDepth: {
        stable:
          'Nessuna linea cambia. La sezione seguente mostra cosa tiene insieme la situazione attuale.',
        boundary:
          'Il cambiamento riguarda il modo in cui la situazione inizia o termina.',
        internal:
          'Il cambiamento riguarda ciò che accade all’interno della situazione.',
        systemic:
          'Il cambiamento raggiunge le fondamenta della situazione e può modificarne il corso.',
      },
      buttons: {
        decide: 'Prendi una decisione',
      },
      more: 'Leggi di più',
      skeleton: {
        loading: 'Caricamento…',
      },
    },
    acceptDecision: {
      back: 'Indietro',
      title: 'Prendi una decisione',
      subtitle:
        'Aggiungi un contesto per ricordare in seguito di cosa si trattava.',
      reading: 'Base della decisione',
      questionLabel: 'Di cosa tratta questa decisione?',
      questionPlaceholder: 'Descrivi brevemente la situazione o la domanda…',
      questionHint: 'Facoltativo. Questo contesto verrà salvato nel diario.',
      confirm: 'Accetta e salva',
      saving: 'Salvataggio…',
      cancel: 'Annulla',
      errorTitle: 'Decisione non salvata',
      errorMessage: 'Riprova.',
    },
  },
  themes: {
    title: 'TEMA',
    dark: 'SCURO',
    light: 'CHIARO',
    autumn: 'AUTUNNO',
    active: 'ATTIVO',
    dark_description: 'Superfici scure con accenti tenui',
    light_description: 'Tema chiaro, pulito e moderno',
    autumn_description: 'Toni caldi e naturali ispirati all’autunno',
  },
  ui: {
    screenTitle: 'TITOLO SCHERMATA',
    info: 'INFO',
    language: 'LINGUA',
    interfaceSettings: 'Lingua e tema',
    loadingStates: {
      loading: 'Caricamento…',
      processing: 'ELABORAZIONE…',
      connecting: 'CONNESSIONE…',
      deleting: 'ELIMINAZIONE…',
    },
  },
  tabs: {
    home: 'Home',
    journal: 'Diario',
    hexagrams: 'Esagrammi',
    profile: 'Profilo',
  },
  desktop: {
    oracle: 'Oracolo',
    brandSubtitle: 'I Ching per le decisioni',
    appearance: 'Aspetto',
    theme: 'Tema dell’interfaccia',
  },
  hexagrams: {
    title: 'Esagrammi',
    subtitle: 'Tutti i 64 segni dell’I Ching — scegli l’ordine che preferisci',
    hint: 'Scegli un segno per aprirne l’interpretazione',
    loading: 'Caricamento del catalogo degli esagrammi…',
    error: 'Impossibile caricare il catalogo degli esagrammi.',
    retry: 'Riprova',
    order: {
      title: 'Ordine',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Fu Xi',
      'fu-xi': 'Fu Xi',
      mawangdui: 'Mawangdui',
    },
    matrix: {
      accessibilityLabel: 'Matrice dei 64 esagrammi. Ordine: {{order}}',
      cellAccessibilityLabel: 'Esagramma {{number}}. {{name}}',
    },
    modal: {
      accessibilityLabel: 'Esagramma {{number}}. {{name}}',
      number: 'Esagramma {{number}}',
      close: 'Chiudi i dettagli dell’esagramma',
      modernTitle: 'Interpretazione moderna',
      pattern: 'Cosa sta accadendo',
      tension: 'Dove sta la difficoltà',
      structureTitle: 'Struttura della situazione',
      visibleStructure: 'Come prende forma la situazione',
      hiddenDynamic: 'Cosa accade sotto la superficie',
      rolesTitle: 'Ruolo dell’esagramma',
      initialRole: 'Quando il segno descrive la situazione attuale',
      resultingRole: 'Quando il segno rappresenta uno stato possibile',
      roleSummary: 'Significato del ruolo',
      action: 'Come agire',
      entry: 'Come entrare in questo stato',
      marker: 'Segnale di progresso',
      linesTitle: 'Sei linee',
      spheresTitle: 'Azione per il tuo tema',
      spheres: {
        general: 'Situazione o scelta',
        newjob: 'Nuovo lavoro',
        work: 'Lavoro attuale',
        love: 'Relazioni',
        project: 'Progetto',
      },
      dailyTitle: 'Guida del giorno',
      dailyFocus: 'Tema del giorno',
      dailyAction: 'Passo pratico',
    },
  },
  journal: {
    actionsFor: 'Azioni per «{{title}}»',
    entryActions: 'Azioni sulla voce',
    deleteConfirm: 'Eliminare la voce?',
    deleteEntry: 'Elimina',
    cancelDelete: 'Annulla',
    deleting: 'Eliminazione…',
    deleteDailyHint:
      'Questo segno verrà rimosso. Se è quello attuale, sarà sostituito dall’ultimo segno rimasto per quella data. Il primo segno del giorno verrà conservato.',
    deleteReadingHint:
      'Questa lettura e la decisione associata verranno eliminate definitivamente.',
    deleteError: 'Impossibile confermare l’eliminazione. Riprova.',
    selectEntry: 'Seleziona una voce del diario',
    entryNotFound: 'Voce non trovata. Selezionane un’altra dall’elenco.',
    title: 'Diario',
    filters: {
      all: 'Tutti',
      decisions: 'Letture',
      daily: 'Segno del giorno',
    },
    searchPlaceholder: 'Cerca per titolo e nota',
    empty: 'Le tue letture appariranno qui',
    emptyHint: 'La prima lettura appare dopo «Inizia una lettura»',
    emptyAll: 'Le voci del tuo diario appariranno qui',
    emptyAllHint: 'Letture e segni del giorno restano nella stessa cronologia',
    emptyDecisions: 'Le tue letture appariranno qui',
    emptyDecisionsHint: 'La prima lettura appare dopo «Inizia una lettura»',
    emptyDaily: 'I tuoi segni del giorno appariranno qui',
    emptyDailyHint: 'Ricevi il primo segno dalla schermata Oracolo',
    error: 'Impossibile caricare il diario',
    errorHint: 'Controlla la connessione e riprova',
    retry: 'Riprova',
    labels: {
      decision: 'Lettura',
      accepted: 'Lettura · decisione annotata',
      daily: 'Segno del giorno',
      question: 'Domanda',
    },
  },
  profile: {
    title: 'Profilo',
    account: {
      title: 'Account',
      loginTelegram: 'Continua con Telegram',
      loginHint:
        'La cronologia dell’account sarà disponibile su tutti i dispositivi; le voci locali resteranno su questo dispositivo',
      loginUnavailable:
        'L’accesso sarà disponibile dopo il collegamento di Telegram Login',
      synchronized: 'I dati dell’account sono sincronizzati tra i dispositivi',
      logout: 'Esci',
      loginErrorTitle: 'Accesso non riuscito',
      loginError: 'Telegram non ha confermato l’accesso. Riprova.',
      logoutErrorTitle: 'Disconnessione non riuscita',
      logoutError: 'Controlla la connessione e riprova.',
    },
    subscription: {
      title: 'Abbonamento',
      active: 'Attivo',
      expired: 'Scaduto',
      free: 'Modalità gratuita',
      activeUntil: 'Attivo fino al {{date}}',
      manage: 'Gestisci abbonamento',
      connect: 'Ottieni Neiro+',
      restore: 'Ripristina acquisti',
      hint: 'Accesso a interpretazioni approfondite, confronti e consigli personali.',
      restored: 'Acquisti ripristinati',
      restoreError: 'Impossibile ripristinare gli acquisti',
      purchaseError: 'Impossibile avviare l’abbonamento nell’App Store',
      loading: 'Verifica dello stato…',
      benefits: {
        privateGroup: 'Accesso al gruppo privato Neiro+',
        earlyUpdates: 'Accesso anticipato agli aggiornamenti di Oracle',
      },
      whatsIncluded: 'Cosa include?',
    },
    notifications: {
      title: 'Notifiche',
      morning: 'Mattino',
      morningHint: 'Scegli quando e dove ricevere il segno del mattino',
      morningEnabledDestinationsHint:
        'Il segno del giorno si rinnova alle {{time}} · {{destinations}}',
      morningDisabledDestinationsHint:
        'Il segno del giorno si rinnova alle {{time}}; le notifiche sono disattivate',
      destinations: {
        title: 'Invia promemoria a',
        local: 'Questo Mac',
        telegram: 'Telegram',
      },
      timeHint: 'Orario del mattino',
      invalidTime: 'Inserisci l’ora nel formato HH:MM, ad esempio 09:00',
      timePicker: {
        title: 'Quando inizia la tua mattina?',
        descriptionEnabled:
          'A quest’ora il segno del giorno si rinnova e il bot Telegram invia un promemoria.',
        descriptionEnabledLocal:
          'A quest’ora il segno del giorno si rinnova e macOS mostra un promemoria.',
        descriptionEnabledMultiple:
          'A quest’ora il segno del giorno si rinnova e i canali selezionati inviano un promemoria.',
        descriptionDisabled:
          'A quest’ora il segno del giorno si rinnova. Le notifiche resteranno disattivate.',
        descriptionChannelUnavailable:
          'A quest’ora il segno del giorno si rinnova. I promemoria inizieranno quando il canale Telegram sarà disponibile.',
        descriptionChannelUnavailableLocal:
          'A quest’ora il segno del giorno si rinnova. macOS chiederà il permesso di inviare notifiche.',
        quickChoice: 'Scelta rapida',
        setPreset: 'Imposta {{time}}',
        hours: 'Ore',
        minutes: 'Minuti',
        decreaseHours: 'Diminuisci di un’ora',
        increaseHours: 'Aumenta di un’ora',
        decreaseMinutes: 'Diminuisci di cinque minuti',
        increaseMinutes: 'Aumenta di cinque minuti',
        directEntryHint: 'Puoi inserire un valore preciso con la tastiera',
        invalidHours: 'Inserisci un’ora da 00 a 23',
        invalidMinutes: 'Inserisci i minuti da 00 a 59',
      },
      loadError: 'Impossibile caricare l’impostazione del mattino',
      saveError: 'Impossibile salvare l’impostazione del mattino',
      retry: 'Riprova',
      testSent: 'Messaggio di prova inviato a Telegram',
      testSentLocal: 'Una notifica di prova apparirà tra due secondi',
      testSentMultiple: 'Promemoria di prova inviati ai canali selezionati',
      testError: 'Impossibile inviare il messaggio di prova',
      channel: {
        active: 'Il bot Telegram è pronto',
        unverified: 'Apri il bot Telegram e conferma la ricezione dei messaggi',
        blocked: 'Il bot Telegram è bloccato. Sbloccalo in Telegram',
        disconnected: 'La connessione al bot Telegram è stata interrotta',
        not_connected: 'Il bot Telegram non è ancora collegato',
      },
      localChannel: {
        active: 'Le notifiche macOS sono consentite',
        unverified: 'L’autorizzazione alle notifiche macOS non è confermata',
        blocked: 'Consenti le notifiche nelle impostazioni macOS',
        disconnected: 'Le notifiche macOS non sono al momento disponibili',
        not_connected:
          'L’autorizzazione verrà richiesta quando attivi i promemoria',
      },
      testNotification: 'Invia prova',
    },
    preferences: {
      title: 'Preferenze',
      haptics: 'Feedback aptico',
      hapticsHint: 'Leggera vibrazione al lancio e al salvataggio',
    },
    classicalText: {
      title: 'Testi degli esagrammi',
      hint: 'Scegli la lettura moderna, il testo tradizionale dello Zhouyi o entrambi',
      modern: 'Moderni',
      classical: 'Classici',
      parallel: 'Entrambi',
    },
    language: {
      interface: 'Lingua dell’interfaccia',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: 'Dati e riservatezza',
      exportJournal: 'Esporta diario',
      exportPeriod: 'Periodo',
      allData: 'Tutti i dati',
      last30Days: 'Ultimi 30 giorni',
      export: 'Esporta',
      exportError: 'Esportazione non riuscita',
      deleteAccount: 'Elimina dati personali e account',
      deleteAccountHint:
        'Dati personali, cronologia, preferenze e account verranno eliminati dall’app',
      deleteAccountConfirm:
        'I dati del profilo, il diario, le preferenze e l’account verranno eliminati. Al prossimo accesso verrà creato un nuovo account. Resteranno solo ricevute tecniche prive di contenuti: quelle di Telegram per 7 giorni per impedire la rielaborazione delle richieste e la conferma di eliminazione per 30 giorni. Al termine di questi periodi, le ricevute verranno rimosse automaticamente.',
      deleteAccountError:
        'Impossibile eliminare i dati personali e l’account. Controlla la connessione e riprova.',
      deleteLocalData: 'Elimina tutti i dati personali',
      deleteLocalDataHint:
        'La cronologia e le preferenze salvate da questa app sul dispositivo verranno eliminate',
      deleteLocalDataConfirm:
        'Tutti i dati salvati da questa app sul dispositivo verranno eliminati. Si aprirà quindi una schermata iniziale vuota.',
      deleteLocalDataError: 'Impossibile eliminare i dati dell’app. Riprova.',
      cancel: 'Annulla',
      deleteAccountAction: 'Elimina account',
      deleteLocalDataAction: 'Elimina dati',
      privacy: 'Informativa sulla privacy',
      terms: 'Termini di utilizzo',
      disclaimer:
        'Per riflessione personale e intrattenimento. Non è un consiglio medico o finanziario.',
    },
    support: {
      title: 'Assistenza',
      guide: 'Come funziona l’Oracolo',
      guideHint: 'Segno del giorno, letture e diario',
      contact: 'Contatta l’assistenza',
      rate: 'Valuta l’app',
      rateNow: 'Valuta ora',
      version: 'Versione {{version}}',
      devTools: 'Strumenti di sviluppo',
      devToolsDesc:
        'Configurazione remota, test push, dati simulati (segnaposto)',
    },
    about: {
      title: 'Informazioni',
      version: 'Versione {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: 'Decidi ora',
  },
};
